import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';

export default function configureStore(defaultState) {
    
    const store = createStore(
        reducers,
        defaultState,
        compose(
            applyMiddleware(thunk),
            (typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined') ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
        )
    );

    return store;
}


// WEBPACK FOOTER //
// ./stores/configureStore.js